<script setup>
import api from "../api/api";
import DescriptionInline from "./DescriptionInline.vue";
import ButtonSubmit from "./ButtonSubmit.vue";
import Swal from "sweetalert2";
import { flashMessage } from "../functions.js";
</script>

<template>
  <div class="surveyTemplateSection">
    <!-- Loading Overlay -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-content">
        <div class="spinner" :style="{ borderTopColor: brandData?.accent_color1 || '#0e5071' }"></div>
        <p class="loading-message">Searching...</p>
      </div>
    </div>

    <form @submit.prevent="searchResult">
      <div>
        <input
          v-model="searchData"
          placeholder="Search for"
          class="searchInput"
          ref="search"
        />
      </div>

      <div class="d-flex">
        <div>
          <ButtonSubmit label="Find" @click="searchResult" type="button" />
        </div>
        <div class="ml-1">
          <ButtonSubmit @click="sendAddProps('add')" label="Add" type="button" />
        </div>
      </div>
    </form>

    <br />

    <v-data-table
      :headers="headers"
      :items="displaySurveyTemplates"
      :items-per-page="perPage"
      :page="page"
      hide-default-footer
      density="compact"
      class="custom-data-table"
    >
      <template v-slot:[`item.index`]="{ index }">
        {{ perPage * (page - 1) + index + 1 }}
      </template>

      <template v-slot:[`item.report_file`]="{ item }">
        <a :href="constructUrl(item.report_file)" target="_blank">{{ item.report_file }}</a>
      </template>

      <template v-slot:[`item.survey_type`]="{ item }">
        {{
          item.survey_type == 3
            ? "Research confirmation"
            : item.survey_type == 2
            ? "360 nominations"
            : item.survey_type == 1
            ? "Self assessment"
            : item.survey_type == 4
            ? "Q-sort"
            : item.survey_type == 5
            ? "VFP"
            : ""
        }}
      </template>

      <template v-slot:[`item.is_coach_report`]="{ item }">
        {{ item.is_coach_report == 1 ? "Yes" : "No" }}
      </template>

      <template v-slot:[`item.is_group_report`]="{ item }">
        {{ item.is_group_report == 1 ? "Yes" : "No" }}
      </template>

      <template v-slot:[`item.is_faculty_report`]="{ item }">
        {{ item.is_faculty_report == 1 ? "Yes" : "No" }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div style="display: flex; flex-direction: column; gap: 10px; width: 100px; margin: 0 auto;">
          <button style="display: flex; align-items: center; justify-content: flex-start; padding: 5px 10px; width: 100%;" @click="sendUpdateProps('update', item.report_template_id, item.report_template_name, item.report_description, item.report_file, item.survey_template_id, item.tag_type, item.survey_template_name, item.survey_file_name, item.survey_type, item.is_coach_report, item.is_group_report, item.is_faculty_report)">
            <font-awesome-icon icon="pencil" style="margin-right: 8px; width: 14px;" />
            <span>Edit</span>
          </button>
          <button style="display: flex; align-items: center; justify-content: flex-start; padding: 5px 10px; width: 100%;" @click="deleteSurveyTemplate(item.report_template_id, item.report_template_name)">
            <font-awesome-icon icon="trash" style="margin-right: 8px; width: 14px;" />
            <span>Delete</span>
          </button>
          <button class="file-upload-button" style="display: flex; align-items: center; justify-content: flex-start; padding: 5px 10px; width: 100%; position: relative;">
            <font-awesome-icon icon="upload" style="margin-right: 8px; width: 14px;" />
            <span>Upload</span>
            <input type="file" @change="uploadHTML($event, item)" accept=".html" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer;" />
          </button>
        </div>
      </template>

      <template v-slot:no-data>
        <p class="font-text-size text-center">No result found.</p>
      </template>
    </v-data-table>

    <!-- pagination -->
    <!-- <div v-show="isPagination" class="pagination">
      <div class="d-flex">
        <div>
          <button type="button" :disabled="isInFirstPage" @click="page--">
            Previous
          </button>
        </div>

        <div
          v-for="pageNumber in pageLength
            ? pages.slice(page - 1, page + 5)
            : pages"
          :key="pageNumber"
          @click="page = pageNumber"
        >
          <button
            style="background-color: #0e5071; color: white"
            v-if="pageNumber == page"
          >
            {{ pageNumber }}
          </button>
          <button v-else>{{ pageNumber }}</button>
        </div>

        <div>
          <button type="button" @click="page++" :disabled="isInLastPage">
            Next
          </button>
        </div>
      </div>
      <div>
        <p class="font-text-size">{{ resultsFound }} results found</p>
      </div>
    </div> -->
    <!-- end of pagination -->
  </div>
</template>

<script>
export default {
  name: 'ManageReportsBox',
  components: [DescriptionInline, ButtonSubmit],
  props: ["userData", "brandData"],
  data: () => ({
    page: 1,
    perPage: 0,
    pages: [],
    isPagination: false,
    resultsFound: "",
    filteredSurveyTemplatesList: [],
    searchData: "",
    noResultFound: false,
    isLoading: false,
    headers: [
      { title: '#', key: 'index', sortable: false, align: 'end' },
      { title: 'Report Name', key: 'report_template_name' },
      { title: 'Report Description', key: 'report_description' },
      { title: 'Report .html', key: 'report_file' },
      { title: 'Survey Name', key: 'survey_template_name' },
      { title: 'Survey File', key: 'survey_file_name' },
      { title: 'Survey Type', key: 'survey_type' },
      { title: 'Coach Report', key: 'is_coach_report' },
      { title: 'Group Report', key: 'is_group_report' },
      { title: 'Faculty Report', key: 'is_faculty_report' },
      { title: 'Action', key: 'actions', sortable: false, align: 'center' },
    ],
  }),
  mounted() {
    api.get(`brands-max-limit/org/${this.userData.org_id}`).then((response) => {
      this.perPage = response.data.max_search_results;
      if (this.perPage == undefined) this.perPage = 25;
    });
  },
  methods: {
    getFolderName() {
      const currentBaseURL = api.defaults.baseURL;
      console.log('currentBaseURL', currentBaseURL)
      if (currentBaseURL == 'https://be.talentsage.com/') {
        return "/var/www/html";
      } else {
        return "/var/www/cert2";
      }
      // Add more conditions as needed
    },
    getFrontendUrl() {
      const backendUrl = api.defaults.baseURL;
      if (backendUrl.includes('uatbe.talentsage.com')) {
        return 'https://uat-ts.talentsage.com/';
      } else if (backendUrl.includes('be.talentsage.com')) {
        return 'https://ts.talentsage.com/';
      }
      // Add more conditions as needed
    },
    constructUrl(reportFile) {
      return `${this.getFrontendUrl()}${reportFile}`;
    },
    async uploadHTML(event, data) {
      const file = event.target.files[0];
      if (!file) return;
      
      this.setLoading = true; // Add loading state
      
      try {
        // Check if the uploaded file has the same name as the existing report file
        if (file.name !== data.report_file) {
          alert(`The file you are trying to upload is not the same as the existing report file "${data.report_file}". Please upload the correct file.`);
          this.setLoading = false;
          return;
        }
        
        // First check if the file already exists on the FTP server
        const folderName = this.getFolderName();
        
        const checkResponse = await api.post('/check-ftp-file-exists', {
          fileName: file.name,
          folderName
        });
        
        // If file exists, prompt the user
        if (checkResponse.data.exists === "-") {
          // Create a backup file name
          const backupFileName = `${file.name.replace('.html', '')}-backup-${new Date().toISOString().replace(/T/, '_').replace(/:/g, '-').replace('Z', '').slice(0, -7)}.html`;
          
          // Show a confirm dialog
          if (confirm(`This report is already uploaded. We will create a backup of the existing report called "${backupFileName}" and then upload the new file. Are you sure?`)) {
            // Upload the file
            const formData = new FormData();
            formData.append('file', file);
            formData.append('folderName', folderName);
            formData.append('backupFileName', backupFileName);
            
            const uploadResponse = await api.post('upload-ftp-file', formData);
            console.log('uploadResponse',uploadResponse)
            // Log the action in user history
            try {
              const historyResponse = await api.post('/create-user-history-log', {
                ind_id: this.userData.ind_id,
                email: this.userData.email,
                screen: 'report Templates', // Adjust this to match your screen name
                action: 'Upload HTML Template',
                action_description: `Uploaded HTML file "${file.name}" for report_template_id ${data.report_template_id}`,
              });
              
              if (historyResponse.status === 200) {
                console.log('user-history-log API return:', historyResponse);
              }
            } catch (historyError) {
              console.log('Error logging user history:', historyError);
              // Continue with the function even if history logging fails
            }
            
            // Show success message and refresh data
            alert('File uploaded successfully!')
            
            this.searchResult(); // Refresh the data
          } else {
            this.setLoading = false;
          }
        } else {
          // Upload the file
          const formData = new FormData();
          formData.append('file', file);
          formData.append('folderName', folderName);
          
          const uploadResponse = await api.post('upload-ftp-file', formData);
          console.log('uploadResponse', uploadResponse)
          // Log the action in user history
          try {
            const historyResponse = await api.post('/create-user-history-log', {
              ind_id: this.userData.ind_id,
              email: this.userData.email,
              screen: 'report Templates', // Adjust this to match your screen name
              action: 'Upload HTML Template',
              action_description: `Uploaded HTML file "${file.name}" for report_template_id ${data.report_template_id}`,
            });
            
            if (historyResponse.status === 200) {
              console.log('user-history-log API return:', historyResponse);
            }
          } catch (historyError) {
            console.log('Error logging user history:', historyError);
            // Continue with the function even if history logging fails
          }
          
          // Show success message and refresh data
          flashMessage(
            this.$flashMessage, 
            this.brandData?.accent_color1 || '#0e5071', 
            this.brandData?.flash_text_color || '#ffffff', 
            'File uploaded successfully!'
          );
          
          this.searchResult(); // Refresh the data
          this.setLoading = false;
        }
      } catch (error) {
        console.log('Upload error:', error);
        flashMessage(
          this.$flashMessage, 
          '#e74c3c', 
          '#ffffff', 
          'Failed to upload file.'
        );
      } finally {
        // Reset the file input to allow selecting the same file again
        event.target.value = '';
      }
    },
    paginate(surveyLists) {
      const from = this.page * this.perPage - this.perPage;
      const to = this.page * this.perPage;
      return surveyLists.slice(from, to);
    },
    searchResult() {
      this.isLoading = true;
      this.pages = [];
      api.get(`report-templates`).then((response) => {
        this.isLoading = false;
        this.pages = [];
        this.page = 1;
        const res = response.data;

        this.filteredSurveyTemplatesList = res.filter((data) => {
          this.noResultFound = false;

          const reportTemplateName = data.report_template_name ? data.report_template_name.toLowerCase() : ''
          const reportDescription = data.report_description ? data.report_description.toLowerCase() : ''
          const reportFile = data.report_file ? data.report_file.toLowerCase() : ''
          const surveyTemplateName = data.survey_template_name ? data.survey_template_name.toLowerCase() : ''
          const surveyFile = data.survey_file ? data.survey_file.toLowerCase() : ''
          const surveyType = data.survey_type ? data.survey_type.toLowerCase() : ''

          return (
            reportTemplateName.includes(this.searchData.toLowerCase()) ||
            reportDescription.includes(this.searchData.toLowerCase()) ||
            reportFile.includes(this.searchData.toLowerCase()) ||
            surveyTemplateName.includes(this.searchData.toLowerCase()) ||
            surveyFile.includes(this.searchData.toLowerCase()) ||
            surveyType.includes(this.searchData.toLowerCase()) 
          );
        })

        this.resultsFound = this.filteredSurveyTemplatesList.length;

        if (this.filteredSurveyTemplatesList.length == 0) {
          this.noResultFound = true;
          this.isPagination = false;
          return;
        }

        let numberOfPages = Math.ceil(
          this.filteredSurveyTemplatesList.length / this.perPage
        );
        for (let index = 1; index <= numberOfPages; index++) {
          this.pages.push(index);
        }
        this.isPagination = true;
      });
    },

    sendAddProps(status) {
      const data = { status: status };
      this.$router.push({
        name: "manage_reports_create_edit",
        params: { data: JSON.stringify(data) },
      });
    },

    sendUpdateProps(
                status,
                report_template_id,                 
                report_template_name,
                report_description,
                report_file,
                survey_template_id,
                tag_type,
                survey_template_name,
                survey_file_name,
                survey_type,
                coach_report,
                coach_group_report,
                faculty_report
                ) {
      const data = {
        status: status,
        report_template_id: report_template_id,
        report_template_name: report_template_name,
        report_description: report_description,
        report_file: report_file,
        survey_template_id: survey_template_id,
        tag_type: tag_type,
        survey_template_name: survey_template_name,
        survey_file: survey_file_name,
        survey_type: survey_type,
        is_coach_report: coach_report,
        is_group_report: coach_group_report,
        is_faculty_report: faculty_report
      };
      this.$router.push({
        name: "manage_reports_create_edit",
        params: { data: JSON.stringify(data) },
      });
    },
    deleteSurveyTemplate(id, name) {
      Swal.fire({
        text: `Are you sure you want to delete the ${name}?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          api
            .delete(`report-template/${id}`)
            .then((res) => {
              console.log(res);
              if (res.status) {
                this.searchResult();
                flashMessage(
                  this.$flashMessage,
                  this.brandData.accent_color1
                    ? this.brandData.accent_color1
                    : "#F47820",
                  this.brandData.flash_text_color
                    ? this.brandData.flash_text_color
                    : "#ffffff",
                  name + " has been deleted!"
                );
              }
            })
            .catch((e) => {
              flashMessage(
                this.$flashMessage,
                this.brandData.accent_color1
                  ? this.brandData.accent_color1
                  : "#F47820",
                this.brandData.flash_text_color
                  ? this.brandData.flash_text_color
                  : "#ffffff",
                e.message
              );
            });
        }
      });
    },
  },
  computed: {
    displaySurveyTemplates() {
      return this.paginate(this.filteredSurveyTemplatesList);
    },
    isInFirstPage() {
      return this.page == 1;
    },
    isInLastPage() {
      return this.page >= this.pages.length;
    },
    pageLength() {
      return this.pages.length > 5;
    },
  },
};
</script>

<style scoped>
.surveyTemplateSection {
  width: 90vw;
}

.custom-data-table {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-data-table :deep(table) {
  border-collapse: collapse;
}

.custom-data-table :deep(thead) {
  background-color: #f5f5f5;
}

.custom-data-table :deep(th) {
  border-bottom: 2px solid #e0e0e0 !important;
  font-weight: 600;
  color: #333;
}

.custom-data-table :deep(td) {
  border-bottom: 1px solid #f0f0f0 !important;
}

.custom-data-table :deep(tbody tr:hover) {
  background-color: #f9f9f9;
}

.custom-data-table :deep(tbody tr:last-child td) {
  border-bottom: none !important;
}

.searchInput {
  outline: 0;
  border-width: 0 0 1px;
  border-color: grey;
  padding: 2px 5px;
  margin: 10px 0px;
  font-size: 14px;
  width: 99%;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-left: 3px;
  margin-right: 3px;
}

.th-text-right {
  text-align: right !important;
}

input, select, option, textarea {
  border: 1px solid grey;
}

.file-upload-button {
  position: relative;
  overflow: hidden;
}

.file-upload-button input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: pointer;
  display: block;
}

/* Loading Overlay Styles */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
  background-color: white;
  padding: 30px 40px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-message {
  color: #333;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}
</style>
